import { Component } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Observable, timer } from 'rxjs';
import { finalize, map, take, takeWhile } from 'rxjs/operators';

import { AuthServerProvider } from '../../core/auth/auth-jwt.service';
import { Timeouts } from '../constants/timeout.constants';
const DEFAULT_COUNT = 30;

/**
 * End Session Component
 * @description Angular component that describe the End session dialog
 * User session have a predefined duration.
 * Before the end of the session, the application prompt this dialog to user
 * and ask him if he wants to stay connected
 */

@Component({
  selector: 'ap-end-session-modal',
  templateUrl: './end-session.component.html',
})
export class EndSessionComponent {
  countFinished = false;
  counter$: Observable<number>;
  count = DEFAULT_COUNT;

  /**
   * Constructor, start countdown timer. After expiration force user to logout
   * @param authServerProvider
   * @param activeModal
   */
  constructor(
    private readonly authServerProvider: AuthServerProvider,
    public activeModal: NgbActiveModal
  ) {
    this.counter$ = timer(0, Timeouts.TIMEOUT_1000).pipe(
      take(this.count),
      map(() => {
        this.count -= 1;
        return this.count;
      }),
      takeWhile(counter => counter >= 0),
      finalize(() => {
        this.countFinished = true;
        this.logout();
      })
    );
  }

  /**
   * Method invoked by user that prefer to logout or by countdown finish
   */
  logout(): void {
    if ((this.count <= 0 && this.countFinished)
      || (this.count > 0 && !this.countFinished)) {
      this.authServerProvider.logout().subscribe();
      this.activeModal.dismiss();
    }
  }

  /**
   * Method invoken when user decide to continue the navigation inside app
   * Reset the session Timer (@see AuthServerProvider) and close the current dialog
   */
  subscribeForNextSessionExpiration(): void {
    this.authServerProvider.clearCloseSessionTimer();
    this.authServerProvider.restoreExpirationSessionTime();
    this.authServerProvider.setupCloseSessionTimer();
    this.activeModal.close();
  }
}
